import { useLocalStorage } from '../hooks/useLocalStorage'
import { IInstanciaEntidade } from '../services/Alegibilidate/types'
import { AuthService } from '../services/Auth'
import { IDataUser } from '../services/Auth/types'
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from 'react'


type Props = {
  children: ReactNode
}

type AuthContextData = {
  isLoadingToken: boolean
  tokenAuth: string,
  load: boolean,
  setLoad: (load: boolean) => void,
  dataUser: IDataUser | undefined,
  getDataUser: (vidaId: string) => Promise<void>,
  companySelected: IInstanciaEntidade | undefined,
  setCompanySelected: (company: IInstanciaEntidade) => void,
  vidaId: string | undefined,
  setVidaId: (vidaId: string) => void,
  instanciaId: string | undefined,
  setInstanciaId: (instanciaId: string) => void
}

export const AuthContext = createContext({} as AuthContextData)

export function AuthProvider({ children }: Props) {
  const [dataUser, setDataUser] = useLocalStorage<IDataUser | undefined>({ storageKey: '@data_user_nhg' })
  const [load, setLoad] = useState(false)
  const [isLoadingToken, setIsLoadingToken] = useState(false)
  const [tokenAuth, setTokenAuth] = useLocalStorage<string>({ storageKey: '@token_nhg' })
  const [vidaId, setVidaId] = useLocalStorage<string>({ storageKey: '@vida_id_nhg' })
  const [instanciaId, setInstanciaId] = useLocalStorage<string>({ storageKey: '@instancia_id_nhg' })
  const [companySelected, setCompanySelected] = useLocalStorage<IInstanciaEntidade>({ storageKey: '@company_selected_nhg' })

  const AuthLoginAnonymous = async () => {
    setIsLoadingToken(true)
    const data = {
      grant_type: 'password',
      username: '8720960000138',
      password: 'HYIntegration@Healthyou#2022'
    }
    try {
      const result = await AuthService.login(data)
      setTokenAuth(result.access_token)
    } finally {
      setIsLoadingToken(false)
    }
  }

  async function getDataUser(vidaId: string) {
    try {
      const result = await AuthService.getDataUser(vidaId)
      if (result) {
        setDataUser(result as IDataUser)
      }
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    AuthLoginAnonymous()
  }, [])


  return (
    <AuthContext.Provider
      value={{
        isLoadingToken,
        tokenAuth: tokenAuth as string,
        load,
        setLoad,
        dataUser,
        getDataUser,
        companySelected,
        setCompanySelected,
        vidaId,
        setVidaId,
        instanciaId,
        setInstanciaId
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  return context
}
